module.exports = __webpack_public_path__ + "img/ikan-galau-1.96e5e36d.svg";